import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined'
import { ListItemIcon, ListItemText, MenuItem, MenuList } from '@mui/material'
import { FC } from 'react'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../components/wrappers/Button'
import { useMixPanel } from '../../../contexts/mixpanel'
import { TtoggleDrawerOnMobile } from '../Sidebar'

interface Props {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const SimulateTournamentCoupons: FC<Props> = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}) => {
  const intl = useIntl()
  const mxp = useMixPanel()

  return (
    <MenuList disablePadding={true} onClick={toggleDrawerOnMobile}>
      <MenuItem
        key="tournament-coupons"
        data-test="simulate_sidebar_menuitem_tournament_coupons"
        component={ButtonLink}
        href="/simulate/tournament-coupons?page=0"
        selected={pathname.includes('/simulate/tournament-coupons')}
        className={nested}
        onClick={() => {
          mxp.track('Sidebar Menu Item (Tournament Coupons)', {
            purpose: 'track clicks of menu elements',
          })
        }}
      >
        <ListItemIcon>
          <ConfirmationNumberOutlinedIcon />
        </ListItemIcon>
        <ListItemText
          primary={intl.formatMessage({
            id: 'sidebar.simulate.tournament.coupons',
          })}
        />
      </MenuItem>
    </MenuList>
  )
}
